import React from 'react';

import './cr-rules-table-entry-selector.less';

export interface ICrRulesTableEntrySelectorProps {
    value?: string;
    record: Record<string, any>;
    selectTableEntry: (entry : number | null) => void;
}

export const CrRulesTableEntrySelector = ({value, selectTableEntry, record}: ICrRulesTableEntrySelectorProps) => (
    <div
        className="cr-rules-entry-selector"
        onClick={() => record.id && selectTableEntry(record.id)}
    >
        {value}
    </div>
);
